import { useInfiniteQuery, useQuery } from '@tanstack/react-query'
import { getLinks } from 'service/list'

export function useGetLinks(pageSize: number, page: number) {
  return useQuery({
    queryKey: ['get-links'],
    queryFn: () => getLinks(pageSize, page),
    staleTime: 0,
  })
}

export function useInfiniteLinks(pageSize: number) {
  return useInfiniteQuery({
    queryKey: ['get-links', pageSize],
    queryFn: async ({ pageParam = 1 }) => getLinks(pageSize, pageParam),

    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage.data.totalCount
      const loadedCount = allPages.flatMap((p) => p.data.links).length
      return loadedCount < totalCount ? allPages.length + 1 : undefined
    },
    initialPageParam: 1, // ✅ 이걸 반드시 명시해야 함
    staleTime: 0,
  })
}
